import { Button } from '@tajdid/tajdid-ui';
import { MailSend02Icon } from 'hugeicons-react';
import { useTranslations } from 'next-intl';

type SuccessStateProps = {
  onBack: () => void;
};

export function SuccessState({ onBack }: SuccessStateProps) {
  const t = useTranslations();

  return (
    <div className="grid place-items-center">
      <MailSend02Icon className="w-16 h-16 my-4 text-primary-500" />
      <h2 className="mb-2 text-2xl font-semibold text-gray-700">
        {t('login.sent-email')}
      </h2>
      <p className="text-center text-gray-700">
        {t('login.sent-email-message')}
      </p>
      <Button onClick={onBack} className="mt-8" variant="outlined" color="gray">
        {t('login.back-to-login-page')}
      </Button>
    </div>
  );
}
